import cn from 'classnames'
import { ShoppingCartOutlined } from '@ant-design/icons'
import Price from '@core/components/Price'
import {
  LYSTypography,
  LYSCard,
  LYSSpacer,
  LYSButton,
} from '@core/components/Primitives'
import { useTranslation } from '@core/i18n/i18n'
import style from './index.module.less'

interface Props {
  productBundlePrice: number
  onAddToCart: () => void
  disabled?: boolean
}

const ProductBundleSummaryRow: React.FC<Props> = ({
  productBundlePrice,
  onAddToCart,
  disabled,
}) => {
  const { t } = useTranslation()

  return (
    <LYSCard
      withBoxShadow={true}
      size={'small'}
      className={cn(style.bundleItemOuter, style.summaryRow)}
    >
      <LYSTypography.Text className={style.sum} visualAppearance={'h3'}>
        {t('productDetail.productBundleSum')}
      </LYSTypography.Text>
      <LYSSpacer />
      <LYSTypography.Text strong={true} className={style.priceLabel}>
        {t('productDetail.productBundlePrice')}
      </LYSTypography.Text>
      <Price value={productBundlePrice} className={style.priceSum} />

      <LYSButton
        icon={<ShoppingCartOutlined rev={undefined} />}
        actionButtonStyle={true}
        type="primary"
        className={style.cartButton}
        size={'large'}
        onClick={onAddToCart}
        disabled={disabled}
      >
        {t('addToCart.addText')}
      </LYSButton>
    </LYSCard>
  )
}

export default ProductBundleSummaryRow
